var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCheckOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#6728FF"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.034 20.632L9.419 16.07l1.305-1.29 3.31 3.272 7.002-6.923 1.305 1.29-8.307 8.214zM6 16c0 5.523 4.478 10 10 10 5.523 0 10-4.477 10-10S21.523 6 16 6C10.478 6 6 10.477 6 16z",
    transform: "translate(-16.000000, -650.000000) translate(16.000000, 650.000000)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheckOn);
export default __webpack_public_path__ + "static/media/ic_check_on.9999fe68a8f752a61945fff8652e1f16.svg";
export { ForwardRef as ReactComponent };